module.exports = __webpack_public_path__ + "img/gq17.6fe2b385.png";